import React, { useState } from "react";
import Modal from "../common/Modal";
import SearchableLocationDropdown from "../common/SearchableLocationDropdown";

const LocationSelector = () => {
    const [open, setOpen] = useState(false);
    const [location, setLocation] = useState("Ahmedabad Warehouse");

    return (
        <div className="card location-card">

            <div className="location-header">
                <div>
                    <strong>Material Location</strong>
                    <p>{location}</p>
                </div>

                <button
                    className="btn-primary"
                    onClick={() => setOpen(true)}
                >
                    Change
                </button>
            </div>

            <Modal open={open} title="Select Location" onClose={() => setOpen(false)}>

                <SearchableLocationDropdown
                    onSelect={(loc) => {
                        setLocation(loc);
                        setOpen(false);
                    }}
                />

                <div className="saved-addresses">
                    <h4>Saved Addresses</h4>
                    <div className="address-item">Mumbai Yard</div>
                    <div className="address-item">Delhi Warehouse</div>
                </div>

                <button className="btn-outline">
                    Use Current Location
                </button>

            </Modal>

        </div>
    );
};

export default LocationSelector;